import React from 'react';
import { styled } from '@compiled/react';
import Badge from '@atlaskit/badge';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { ITEM_LINE_HEIGHT } from '../../../../../common/constants.tsx';
import { messages } from './messages.tsx';
import type { BulkIndicatorProps } from './types.tsx';

export const BulkIndicator = ({ selectedCount }: BulkIndicatorProps) => {
	const { formatMessage } = useIntl();

	return (
		<BulkIndicatorContainer tabIndex={-1}>
			<Badge appearance="primary">{selectedCount}</Badge> {formatMessage(messages.selected)}
		</BulkIndicatorContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BulkIndicatorContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: ITEM_LINE_HEIGHT,
	display: 'flex',
	paddingTop: '0px',
	paddingRight: token('space.250'),
	paddingBottom: '0px',
	paddingLeft: token('space.250'),
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	textTransform: 'uppercase',

	color: token('color.text.subtle'),
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.medium'),
	gap: token('space.100'),
});
